"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.solmate = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
exports.solmate = require("./solmate");
//# sourceMappingURL=index.js.map